<template>
    <div class="">
        <div class="setting_box">
            <div class="setting_detail">
                使用方法：在地图画出需要打卡的区域，因手机GPS定位会有10米左右偏差，可留些多余区域。
            </div>
            <div class="setting_detail2">
                <span>绘制：鼠标左键点击及移动即可绘制图形,鼠标左键双击即可完成绘制。 </span>
                <span>中断：绘制过程中按下esc键可中断该过程</span>
              
            </div>
        </div>
        <div class="setting_box2">
            <div>
                <span>当前中心坐标：</span>
                <Input @on-enter="set_map_center" v-model="central_point_str" size="small" placeholder="当前中心坐标" style="width: 300px" />
                <a  style="color:#0466dd;margin-left:10px" href="https://lbs.qq.com/getPoint/" target="_blank">坐标拾取器</a>
                <a  style="color:#0466dd;margin-left:10px" @click='set_map_center' target="_blank">回到中心点</a>
            </div>

        </div>
        <div class="map_div">
            <div id="container"></div>

        </div>

    </div>



</template>

<script>
import { http } from "@/utils/http.js";

export default {
    name: 'daka_setting',
    props: ['current_project'],
    components: {
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            central_point: { 'lat': 0, 'lng': 0 },
            central_point_str: '',
            editor: null,
            map: null,
            polygon: null,
            path_data: [],
            geometries_path: [],


        }
    },

    mounted() {
        this.get_daka_info()

    },

    methods: {

        //更新签到地图
        update_sign_in_map() {
            var that = this
            var obj = {
                project_id: that.current_project.project_id,
                path_list: that.path_data
            }

            http("post", process.env.VUE_APP_HOST + "/daily/sign_in/update_sign_map", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.update_duobianxing_map()
                        // that.current_polygon.remove(['polygon_1])
                        // that.editor.destroy()	

                        // that.initMap()


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },


        //获取打卡详情
        get_daka_info() {
            var that = this
            var obj = {
                project_id: that.current_project.project_id,

            }

            http("post", process.env.VUE_APP_HOST + "/daily/sign_in/daka_info", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        if (res.data.status) {
                            that.path_data = res.data.path_list
                            that.central_point = res.data.central_point
                            that.central_point_str = res.data.central_point_str
                            // 开始绘制多边形
                            that.initMap()
                        } else {
                            that.initMap()

                        }
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },


        set_map_center(){
            var central_point_list = this.central_point_str.split(',')
            this.map.setCenter(new TMap.LatLng(central_point_list[0],central_point_list[1]));
            this.$Message.success('设置中心点成功')
        },




        initMap() {

            var that = this
            // 初始化地图
            this.map = new TMap.Map('container', {
                zoom: 19, // 设置地图缩放级别
                center: new TMap.LatLng(that.central_point.lat, that.central_point.lng), // 设置地图中心点坐标
                viewMode: '2D'
            });


            // 设置多边型
            that.polygon = new TMap.MultiPolygon({
                map: this.map,
            });

            //多边型
            that.editor = new TMap.tools.GeometryEditor({
                // TMap.tools.GeometryEditor 文档地址：https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocEditor
                map: this.map, // 编辑器绑定的地图对象
                // 支持的几何图形
                overlayList: [
                    {
                        overlay: that.polygon,
                        id: 'polygon',
                    },
                ],
                actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
                activeOverlayId: 'polygon', // 激活图层
                snappable: true, // 开启吸附
            });
            // 监听绘制结束事件，获取绘制几何图形
            this.editor.on('draw_complete', (geometry) => {
                console.log(1111, geometry)
                that.path_data = geometry.paths
                that.$Message.success('绘制成功')
                that.update_sign_in_map()

                // 判断当前处于编辑状态的图层id是否是overlayList中id为rectangle（矩形）图层
                // if (this.editor.getActiveOverlay().id === 'rectangle') {
                //     // 获取矩形顶点坐标
                //     var id = geometry.id;
                //     var geo = rectangle.geometries.filter(function (item) {
                //         return item.id === id;
                //     });
                //     console.log('绘制的矩形定位的坐标：', geo[0].paths);
                // }
            });

            that.update_duobianxing_map()


        },

        //更新地图多边形
        update_duobianxing_map() {
            var that = this

            var path = [ //多边形轮廓点串（LatLng数组）
                // new TMap.LatLng(40.041054, 116.272303),
                // new TMap.LatLng(40.039419, 116.272721),
                // new TMap.LatLng(40.039764, 116.274824),
                // new TMap.LatLng(40.041374, 116.274491),
            ]
            for (let i = 0; i < this.path_data.length; i++) {
                path.push(new TMap.LatLng(
                    this.path_data[i]['lat'],
                    this.path_data[i]['lng']
                ))
            }



            var polygon_dict = {
                id: 'polygon_1', //图层id
                map: this.map, //设置多边形图层显示到哪个地图实例中
                //多边形样式
                styles: {
                    'polygon': new TMap.PolygonStyle({
                        'color': 'rgba(41,91,255,0.16)', //面填充色
                        'showBorder': true, //是否显示拔起面的边线
                        'borderColor': 'rgba(41,91,255,1)', //边线颜色
                        'borderWidth': 2,
                    })
                },
                //多边形数据
                geometries: [
                    {
                        'id': 'p1', //该多边形在图层中的唯一标识（删除、更新数据时需要）
                        'styleId': 'polygon', //绑定样式名
                        'paths': path, //多边形轮廓
                    }
                ]
            }

            if (this.current_polygon) {
                console.log('图层存在,删除现有图层')
                // this.current_polygon.remove(['polygon_1'])
                this.current_polygon.setMap(null)
                // this.current_polygon.setGeometries(polygon_dict['geometries'])

            }
            //初始化polygon
            this.current_polygon = new TMap.MultiPolygon(polygon_dict);

        },

        tab_remove(e) {
            console.log(e)

            var that = this
            this.$Modal.confirm({
                title: '危险操作',
                content: '<p>你正在删除班次，是否真的要删除？</p>',
                onOk: () => {
                    var obj = {
                        project_id: that.current_project.project_id,
                        shift_id: that.shift_list[e]['shift_id']
                    }

                    http("post", process.env.VUE_APP_HOST + "/daily/del_shift", obj, true).then(
                        (res) => {
                            if (res.code == 0) {
                                that.$Message.success({
                                    content: res.msg,
                                    duration: 3,
                                });
                                that.get_shift_list()
                            } else {
                                that.$Message.error({
                                    content: res.msg,
                                    duration: 3,
                                });
                            }

                        }
                    ).catch((res) => {
                        console.log(res, '请求出错')
                    })
                },
                onCancel: () => {

                }
            });



        },



        get_shift_list() {

            var that = this
            var year = this.current_day.getFullYear()
            var month = this.current_day.getMonth() + 1
            var day = this.current_day.getDate()
            var obj = {
                project_id: this.current_project.project_id,

                year: year,
                month: month,
                day: day,

            }

            http("post", process.env.VUE_APP_HOST + "/daily/shift_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.shift_list = res.data.shift_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {


                console.log(res, '请求出错')
            })
        },

        affirm_add_shift() {

            var that = this
            var year = this.current_day.getFullYear()
            var month = this.current_day.getMonth() + 1
            var day = this.current_day.getDate()
            var obj = {
                project_id: this.current_project.project_id,
                name: this.add_shift_name,
                year: year,
                month: month,
                day: day,
                start_time: this.add_shift_start_time,
                end_time: this.add_shift_end_time
            }

            if (!year) {
                this.$Message.error('年异常')
                return
            }
            if (!month) {
                this.$Message.error('年异常')
                return
            }
            if (!day) {
                this.$Message.error('年异常')
                return
            }
            if (!obj.project_id) {
                this.$Message.error('项目id异常')
                return
            }
            if (!obj.name) {
                this.$Message.error('请输入别名')
                return
            }
            if (!obj.start_time) {
                this.$Message.error('请选择班次开始时段')
                return
            }
            if (!obj.end_time) {
                this.$Message.error('请选择班次结束时段')
                return
            }

            this.add_shift_loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/create_shift", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_shift_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.add_shift_loading = false
                    that.add_shift_show = false
                }
            ).catch((res) => {
                that.add_shift_loading = false

                console.log(res, '请求出错')
            })
        },

        //点击新班次
        add_shift() {
            this.add_shift_show = true
        },


        //获取用户列表
        get_user_list() {
            var that = this
            var obj = {
                page: this.page
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/user_manage/user_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.table_data = res.data.table_data
                        that.columns = res.data.columns

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.setting_box2{
    border-top:1px dashed #ccc;

    padding:10px 10px 10px 10px;
    font-size: 13px;
}

.setting_detail {
    color: #666;
    font-size: 13px;
}

.setting_detail2 {
    font-size: 13px;
    color: #666;
}

.setting_box {
    padding: 0 10px 10px 10px;
}

.map_div {
    height: calc(100vh - 150px);
}

#container {
    width: 100%;
    height: 100%;
}

#toolControl {
    position: absolute;
    top: 60px;
    left: 0px;
    right: 0px;
    margin: auto;
    width: 252px;
    z-index: 1001;
}

.toolItem {
    width: 30px;
    height: 30px;
    float: left;
    margin: 1px;
    padding: 4px;
    border-radius: 3px;
    background-size: 30px 30px;
    background-position: 4px 4px;
    background-repeat: no-repeat;
    box-shadow: 0 1px 2px 0 #e4e7ef;
    background-color: #ffffff;
    border: 1px solid #ffffff;
}

.toolItem:hover {
    border-color: #789cff;
}

.active {
    border-color: #d5dff2;
    background-color: #d5dff2;
}

/* #marker {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker_editor.png');
}

#polyline {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/polyline.png');
}

#polygon {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/polygon.png');
}

#circle {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/circle.png');
}

#rectangle {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/rectangle.png');
}

#ellipse {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/ellipse.png');
} */

.add_shift_field_title {
    width: 120px;
    flex-shrink: 0;
}

.add_shift_field {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
}

.button_div {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    ;
}

.tabs_div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
}

.tabs_div_left {
    display: flex;
    align-items: center;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

:deep(.ivu-tabs-bar) {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
    padding: 10px;
}

.main {
    background: #f5f7f9;
    padding: 10px;
}
</style>